import { DispatchLockingSystemReducer, LockingSystemReducerState } from ".."
import { _getAddDefaultKeyComponentPayload } from "./key"
import { _getAddDefaultLockingComponentPayload } from "./locking"

export const addInitialComponents = (
	dispatch: DispatchLockingSystemReducer,
	reducerState: LockingSystemReducerState,
	numberOfLockingComponents: number,
	numberOfKeyComponents: number,
) => {
	const lockingComponentPayload = _getAddDefaultLockingComponentPayload(
		reducerState,
		numberOfLockingComponents - 1,
	)
	const updatedReducerState = {
		...reducerState,
		...lockingComponentPayload,
	}

	const keyComponentPayload = _getAddDefaultKeyComponentPayload(
		updatedReducerState,
		numberOfKeyComponents - 1,
	)

	dispatch({
		type: "ADD_INITIAL_COMPONENT",
		payload: {
			...keyComponentPayload,
			lockingComponentsUuids: lockingComponentPayload.lockingComponentsUuids,
		},
	})
}
